import { useEffect, useState, useCallback } from 'react';
import { apiClient } from '../api';
import { ONLINE_POLL_INTERVAL_MS } from '../constants';

// Polls /api/users/online every ONLINE_POLL_INTERVAL_MS and exposes a Set of
// online user_ids. Used by Browse, ProfileDetail, Chat to render presence
// indicators.
export const useOnlineUsers = () => {
  const [online, setOnline] = useState(new Set());

  const refresh = useCallback(async () => {
    try {
      const res = await apiClient.get('/users/online');
      setOnline(new Set(res.data.online || []));
    } catch (err) {
      // Presence is non-critical — log and continue
      console.warn('Failed to refresh online presence:', err?.message || err);
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, ONLINE_POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [refresh]);

  return { online, refresh };
};
